import React from 'react';
import styled from 'styled-components';
import { Icon } from './_base';

const WellGuideSVG = styled(Icon).attrs({ viewBox: '0 0 41 40' })`
    width: 1.025em;
`;

function WellGuideIcon({ color = 'currentColor', ...props }) {
    return (
        <WellGuideSVG data-test="icon-well-guide" {...props}>
            <path
                d="M20.5,40a20,20,0,1,1,20-20A20,20,0,0,1,20.5,40Zm0-35.72A15.71,15.71,0,1,0,36.21,20,15.73,15.73,0,0,0,20.5,4.28Zm0,26.79A11.08,11.08,0,0,1,9.43,20h4.29a6.79,6.79,0,1,0,13.57,0h4.29A11.08,11.08,0,0,1,20.5,31.07Z"
                fill={color}
            />
        </WellGuideSVG>
    );
}

export { WellGuideIcon as default, WellGuideIcon };
